<template>
  <div class="agreement_body">
    <div class="mt43">
      <div class="f13 c333 fStart aic">
        <i class="bgff8200 w3 h13 dl mr9"></i>1.贴现业务处理行:
        <a-select class="ml20 w180 h23 f12 br4 pinganCredit_businessBank" :class="[isNull('businessBank')?'red': '']" size="small" style="width: 120px" v-model="agreementData.pinganData.creditDto.businessBank" placeholder="请选择贴现业务处理行">
          <a-select-option v-for="item in businessBankListOptions" :value="item.code" :key="item.name">
            {{item.name}}
          </a-select-option>
        </a-select>
        <div class="tip pr dp-c-primary-text fcenter c4772FF">
          <img class=" ml10  mr4" src="~@/assets/img/account/ruhexuanze.png" alt=""> 如何选择
          <div class="tipShow ">贴现业务处理行与贵企业所在地无关，建议择近选择</div>
        </div>
      </div>
    </div>
    <!-- 1.企业信息 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>2.企业信息</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart">
            <div class="mr13 beforeStar w150 tr">营业执照：</div>
            <div class="pinganCredit_blicPic " :class="[isNull('blicPic')?'red': '',agreementData.pinganData.creditDto.blicPic?'': 'blicPicOss', 'pr', 'imgUpload']">
              <imgUpload :width="'140px'" :height="'140px'" @change="handleChange" :params="{ocr: {  picType:'blicPicOss'} }" :showUrl="agreementData.pinganData.creditDto.blicPic" :format="['png','jpg']" :picType="'blicPicOss'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>

          </div>
        </div>

        <div class="c999 ml150 mt13">将原件复印后加盖鲜章，上传扫描件。</div>

        <div class="fStart mt22">
          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">证件类型：</div>
            <a-select class=" w180 h23 f12 br4 pinganCredit_artifCertIdType" :class="[isNull('idType')?'red': '']" size="small" placeholder="请填选择证件类型" default-value="lucy" style="width: 120px" v-model="agreementData.pinganData.creditDto.idType">
              <a-select-option value="1">
                统一社会信用代码
              </a-select-option>
            </a-select>
          </div>

          <div class="fStart w33b" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">企业名称：</div>
            <a-input class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_enterpriseName" :class="[isNull('name')?'red': '']" placeholder="请输入企业名称" v-model="agreementData.pinganData.creditDto.name" />
          </div>



          <div class="fStart w33b">
            <div class="mr13 beforeStar w150 tr">社会统一信用代码：</div>
            <a-input readOnly type="text" class="be9e9e9 w180 h23  f12 br4 pl7 pinganCredit_compIdtNo" :class="[isNull('idNo')?'red': '']" placeholder="请输入社会统一信用代码" v-model="agreementData.pinganData.creditDto.idNo" :max-length=18 />
          </div>

        </div>

        <div class="fStart mt22 aifs">

          <div class=" w33b ">
            <div class="fStart aic">
              <div class="mr13 beforeStar w150 tr">年销售额：</div>
              <a-input type="text" v-double-only class="be9e9e9 w180 h23 f12 br4 pl7 mr6 pinganCredit_totalAssets moneyType" :class="[isNull('salesRevenue')?'red': '']" placeholder="请填写年销售额" v-model="agreementData.pinganData.creditDto.salesRevenue" />元
            </div>
            <p class="w100b"><span class="c4772FF dl ml170  ">{{digitUppercase(agreementData.pinganData.creditDto.salesRevenue)}}</span></p>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">国税纳税人识别号：</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_artifTelephone" :class="[isNull('nationalTaxNo')?'red': '']" placeholder="请填写国税纳税人识别号" :max-length=18 v-model="agreementData.pinganData.creditDto.nationalTaxNo" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">地税纳税人识别号：</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_artifTelephone" :class="[isNull('localTaxNo')?'red': '']" placeholder="请填写地税纳税人识别号" :max-length=18 v-model="agreementData.pinganData.creditDto.localTaxNo" />
          </div>
        </div>
      </div>
    </div>

    <!-- 2身份证 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>3.法人信息</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">人像面：</div>
            <div class="pinganCredit_lepPicA" :class="[isNull('lepPicA')?'red': '',agreementData.pinganData.creditDto.lepPicA?'': 'lepPicAOss', 'pr', 'imgUpload']">
              <imgUpload :width="'200px'" :height="'100px'" @change="handleChange" :params="{ocr: {  picType:'lepPicAOss'} }" :showUrl="agreementData.pinganData.creditDto.lepPicA" :format="['png','']" :picType="'lepPicAOss'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">国徽面：</div>
            <div class="pinganCredit_lepPicB" :class="[isNull('lepPicB')?'red': '',agreementData.pinganData.creditDto.lepPicB?'': 'lepPicBOss', 'pr', 'imgUpload']">
              <imgUpload :width="'200px'" :height="'100px'" @change="handleChange" :params="{ocr: {  picType:'lepPicBOss'} }" :showUrl="agreementData.pinganData.creditDto.lepPicB" :format="['png','jpg']" :picType="'lepPicBOss'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>
          </div>
        </div>


        <div class="fStart mt22 ">
          <div class="fStart w33b aic" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">证件类型:</div>
            <a-select class=" w180 h23 f12 br4 pinganCredit_artifCertIdType" :class="[isNull('legalPsnIdType')?'red': '']" size="small" placeholder="请填选择证件类型" default-value="1" style="width: 120px" v-model="agreementData.pinganData.creditDto.legalPsnIdType">
              <a-select-option value="1">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div class="fStart w33b aic" v-if="agreementData.baseDate">
            <div class="mr13 beforeStar w150 tr">法人姓名：</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_artifName" :class="[isNull('legalPsnName')?'red': '']" placeholder="法人姓名" v-model="agreementData.pinganData.creditDto.legalPsnName" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">身份证号码：</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_artifCertId" :class="[isNull('legalPsnIdNo')?'red': '']" placeholder="请输入身份证号码" v-model="agreementData.pinganData.creditDto.legalPsnIdNo" :max-length=18 />
          </div>


        </div>
        <div class="fStart mt22">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">法人证件到期日：</div>
            <a-date-picker class=" w180  noLine  pinganCredit_artifIdtEndDate" :class="[isNull('legalPsnIdDueDate')?'red': '']" @change="onCheckedDate('legalPsnIdDueDate')" size="small" placeholder="请选择到期日" v-model="agreementData.pinganData.creditDto.legalPsnIdDueDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="langDate('legalPsnIdDueDate')">长期</a-button>
            </a-date-picker>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">所在地区：</div>
            <a-cascader :options="agreementData.baseDate.areaCodeList" :field-names="{ label: 'name', value: 'code', children: 'subList' }" :value="legalPsnAddress()" class="w180" placeholder="请选择地区" size="small" @change="onChange($event,'legalPsn')" />
          </div>



          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">详细地址：</div>
            <a-textarea v-model="agreementData.pinganData.creditDto.legalPsnDetailAddr" :class="[isNull('legalPsnDetailAddr')?'red': '', 'w180']" placeholder="请填写详细地址" :rows="2" />
          </div>
        </div>
      </div>
    </div>

    <!-- 3.经办人信息 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>4.经办人信息</div>
      <div class="content">
        <div class="fStart mt22">
          <div class="fStart w50b ">
            <div class="mr13 beforeStar w150 tr">经办人姓名：</div>
            <div class="fCStart w100b">
              <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_oprrName" :class="[handleValidate('oprrName')?'red': '']" placeholder="请填写经办人姓名" v-model="agreementData.pinganData.creditDto.oprrName" />
            </div>
          </div>

          <div class="fStart w50b ">
            <div class="mr13 beforeStar w150 tr">经办人手机号：</div>
            <div class="fCStart w100b">
              <a-input v-number-only type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_oprrTel" :class="[handleValidate('oprrTel')?'red': '']" placeholder="请填写经办人证件号码" v-model="agreementData.pinganData.creditDto.oprrTel" :max-length=11 />

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 5.控股人信息 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>5.控股人信息</div>
      <div class="content">
        <div class="mt17 fStart">
          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">股东类型：</div>
            <a-select class=" w180 h23 f12 br4 pinganCredit_telephone" :class="[isNull('shareholderType')?'red': '']" size="small" placeholder="请填选择股东类型" default-value="0" style="width: 120px" v-model="agreementData.pinganData.creditDto.shareholderType" @change="shareholderTypeChange">
              <a-select-option value="0">
                个人
              </a-select-option>
              <a-select-option value="1">
                企业
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="mt17 fStart" v-if="agreementData.pinganData.creditDto.shareholderType=== '1'">
          <div class="fStart">
            <div class="mr13 beforeStar w150 tr">营业执照：</div>
            <div class="pinganCredit_blicPic " :class="[isNull('stockholderBilcFile')?'red': '',agreementData.pinganData.creditDto.stockholderBilcFile?'': 'blicPicOss', 'pr', 'imgUpload']">
              <imgUpload :width="'140px'" :height="'140px'" @change="stockholderChange" :params="{ocr: {  picType:'blicPicOss'} }" :showUrl="agreementData.pinganData.creditDto.stockholderBilcFile" :format="['png','jpg']" :picType="'stockholderBilcFile'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>

          </div>
        </div>
        <div class="mt17 fStart" v-else>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">身份证人像面：</div>
            <div class="pinganCredit_aupPicA" :class="[isNull('stockholderCertAFile')?'red': '',agreementData.pinganData.creditDto.stockholderCertAFile?'': 'lepPicAOss', 'pr', 'imgUpload']">
              <imgUpload :width="'200px'" :height="'100px'" @change="handleChange" :params="{ocr: {  picType:'aupPicAOss'} }" :showUrl="agreementData.pinganData.creditDto.stockholderCertAFile" :format="['png','jpg']" :picType="'stockholderCertAFile'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>
          </div>
          <div class="fStart w50b">
            <div class="mr13 beforeStar w150 tr">身份证国徽面：</div>
            <div class="pinganCredit_aupPicB" :class="[isNull('stockholderCertBFile')?'red': '',agreementData.pinganData.creditDto.stockholderCertBFile?'': 'lepPicBOss', 'pr', 'imgUpload']">
              <imgUpload :width="'200px'" :height="'100px'" @change="handleChange" :params="{ocr: {  picType:'aupPicBOss'} }" :showUrl="agreementData.pinganData.creditDto.stockholderCertBFile" :format="['png','jpg']" :picType="'stockholderCertBFile'">
                <template v-slot:all>
                  <div class="pa pac tc">
                    <img src="~@/assets/img/account/icon_sczp.png" class="w70b" alt="">
                    <p class=" mt5 f12">选择上传</p>
                  </div>
                </template>
              </imgUpload>
            </div>
          </div>
        </div>
        <div class="fStart mt22">
          <div class="fStart w33b aic" v-if="agreementData.pinganData.creditDto.shareholderType!== '1'">
            <div class="mr13  w150 tr" :class="[agreementData.pinganData.creditDto.shareholderType=== '1'?'': 'beforeStar']">证件类型：</div>
            <a-select class=" w180 h23 f12 br4 pinganCredit_telephone" :class="[(agreementData.pinganData.creditDto.shareholderType!== '1'&&isNull('shareholderIdType'))?'red': '']" size="small" placeholder="请填选择证件类型" style="width: 120px" v-model="agreementData.pinganData.creditDto.shareholderIdType">
              <a-select-option value="1">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">{{agreementData.pinganData.creditDto.shareholderType!== '1'?'企业名称': '股东姓名：'}}</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_owner" :class="[isNull('shareholderName')?'red': '']" placeholder="请填写股东姓名" v-model="agreementData.pinganData.creditDto.shareholderName" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">{{agreementData.pinganData.creditDto.shareholderType=== '1'?'社会统一信用代码：': '股东证件号码：'}}</div>
            <a-input type="text" class="be9e9e9 w180 h23 f12 br4 pl7 pinganCredit_owerCertId" :class="[isNull('shareholderIdNo')?'red': '']" placeholder="请填写股东证件号码" v-model="agreementData.pinganData.creditDto.shareholderIdNo" :max-length=18 />
          </div>


          <div class="fStart w33b aic" v-if="agreementData.pinganData.creditDto.shareholderType === '1'">
            <div class="mr13 beforeStar w150 tr">股东证件到期日：</div>
            <a-date-picker class=" w180  noLine  pinganCredit_shareholderIdDueDate" :class="[isNull('shareholderIdDueDate')?'red': '']" size="small" @change="onCheckedDate('shareholderIdDueDate')" placeholder="请选择到期日" v-model="agreementData.pinganData.creditDto.shareholderIdDueDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="langDate('shareholderIdDueDate')">长期</a-button>
            </a-date-picker>
          </div>
        </div>

        <div class="fStart mt22">


          <div class="fStart w33b aic" v-if="agreementData.pinganData.creditDto.shareholderType!== '1'">
            <div class="mr13 beforeStar w150 tr">股东证件到期日：</div>
            <a-date-picker class=" w180  noLine  pinganCredit_shareholderIdDueDate" :class="[isNull('shareholderIdDueDate')?'red': '']" size="small" @change="onCheckedDate('shareholderIdDueDate')" placeholder="请选择到期日" v-model="agreementData.pinganData.creditDto.shareholderIdDueDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="langDate('shareholderIdDueDate')">长期</a-button>
            </a-date-picker>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">所在地区：</div>
            <a-cascader :options="agreementData.baseDate.areaCodeList" :field-names="{ label: 'name', value: 'code', children: 'subList' }" :value="shareholderAddress()" class="w180" placeholder="请选择股东联系地区" size="small" @change="onChange($event,'shareholder')" :class="[isNull('shareholderProvCd')?'red': '']" />
          </div>

          <div class="fStart w33b aic">
            <div class="mr13 beforeStar w150 tr">详细地址：</div>
            <a-textarea v-model="agreementData.pinganData.creditDto.shareholderDetailAddr" :class="[isNull('shareholderDetailAddr')?'red': '', 'w180']" placeholder="请填写股东详细联系地址" :rows="2" />
          </div>
        </div>

      </div>
    </div>

    <!-- 6.受益人信息 -->
    <div class="mt43 benefitCert">
      <div class="f13 c333">
        <i class="bgff8200 w3 h13 dl mr9"></i><span>6.受益人信息</span> <span class="beforeStar"></span>
        <span class="c4772FF fr cp add_stockholder_sanxiang" @click="addBeneficiary">+增加</span>
      </div>
      <div class="content">
        <a-table :columns="benefitArray.columns" :data-source="agreementData.pinganData.creditDto.beneficiaryList" :pagination="false" class="w100b be9e9e9 bsb mt22">
          <div slot="name" slot-scope="text, record,index" class="">
            <a-input class="be9e9e9 w84" :class="[isNull('name','beneficiaryList',index)?'red': '']" placeholder="请填写姓名" size="small" v-model="agreementData.pinganData.creditDto.beneficiaryList[index].name"></a-input>
          </div>

          <div slot="idType" slot-scope="text, record,index" class="">
            <a-select class=" w90 h23 f12 br4 " :class="[isNull('idType','beneficiaryList',index)?'red': '']" size="small" placeholder="请填选择证件类型" default-value="0" style="width: 120px" v-model="agreementData.pinganData.creditDto.beneficiaryList[index].idType">
              <a-select-option value="1">
                身份证
              </a-select-option>
            </a-select>
          </div>

          <div slot="idNo" slot-scope="text, record,index" class="">
            <a-input class="be9e9e9 w130" :class="[isNull('idNo','beneficiaryList',index)?'red': '']" size="small" placeholder="请填证件号码" v-model="agreementData.pinganData.creditDto.beneficiaryList[index].idNo" :max-length=18></a-input>
          </div>

          <div slot="provCd" slot-scope="text, record,index" class="">
            <a-cascader :options="agreementData.baseDate.areaCodeList" :field-names="{ label: 'name', value: 'code', children: 'subList' }" :value="benefitCertAddress(record)" :class="[isNull('cityCd','beneficiaryList',index)?'red': '', 'w130']" placeholder="请选择地址" size="small" @change="onChange($event, record)" />
          </div>

          <div slot="detailAddr" slot-scope="text, record,index" class="">
            <a-textarea v-model="agreementData.pinganData.creditDto.beneficiaryList[index].detailAddr" :class="[isNull('detailAddr','beneficiaryList',index)?'red': '', 'w120']" placeholder="请填写详细联系地址" :rows="2" />
          </div>

          <div slot="idNoDueDate" slot-scope="text, record,index" class="">
            <a-date-picker class=" w120 " :class="[isNull('idNoDueDate','beneficiaryList',index)?'red': '']" @change="onCheckedDate('idNoDueDate','beneficiaryList',index)" size="small" placeholder="请选择到期日" v-model="agreementData.pinganData.creditDto.beneficiaryList[index].idNoDueDate">
              <a-button type="" size="small" slot="renderExtraFooter" @click="langDate('idNoDueDate','beneficiaryList', index)">长期</a-button>
            </a-date-picker>
          </div>

          <div slot="benefitCertAFile" slot-scope="text, record,index" class="pinganCredit_lepPicA " :class="[isNull('benefitCertAFile','beneficiaryList',index)?'red': '']">
            <div class="pr" v-if="!record.benefitCertAFile">
              <img src="~@/assets/img/account/bg_shenfenzhengrenxiang_sc.png" class="cp p3 w70" alt="" @click="imgUploadClicks(`imgUpload${index}`,'img',index)">
              <img src="~@/assets/img/account/icon_xiangji.png" class="pa b0 r0 w24b" alt="">
            </div>
            <imgUpload v-show="record.benefitCertAFile" :ref="`imgUpload${index}`" @change="benefitCertAFileChange" :params="{ocr: {  picType:'lepPicAOss'} }" :showUrl="record.benefitCertAFile" :format="['png','jpg']">
            </imgUpload>
          </div>
          <div slot="benefitCertBFile" slot-scope="text, record,index" class="pinganCredit_lepPicA " :class="[isNull('benefitCertBFile','beneficiaryList',index)?'red': '']">
            <div class="pr" v-if="!record.benefitCertBFile">
              <img src="~@/assets/img/account/bg_shenfenzhengguohui_sc.png" class="cp p3 w70" alt="" @click="imgUploadClicks(`imgUploadB${index}`,'img',index)">
              <img src="~@/assets/img/account/icon_xiangji.png" class="pa b0 r0 w24b" alt="">
            </div>
            <imgUpload class="" v-show="record.benefitCertBFile" :ref="`imgUploadB${index}`" @change="benefitCertBFileChange" :params="{ocr: {  picType:'lepPicBOss'} }" :showUrl="record.benefitCertBFile" :format="['png','jpg']" :picType="'benefitCertBFile'">
            </imgUpload>
          </div>

          <span slot="action" slot-scope="text,record,index"><i class="icon remove cp del_stockholder_sanxiang" @click="deleteBeneficiary(index)"></i></span>
        </a-table>
      </div>
    </div>

    <!-- 6.贴现账户 -->
    <div class="mt43">
      <div class="f13 c333">
        <i class="bgff8200 w3 h13 dl mr9"></i><span>7.贴现账户 <span class="f12  c4772FF">即为贴现票据所在网银，建议将公司名下所有网银添加至列表，至少一个，至多五个</span></span>
        <span class="c4772FF fr cp add_stockholder_sanxiang" @click="addStockHolder">+增加</span>
      </div>
      <div class="content">
        <a-table :columns="acctInfoList.columns" :data-source="agreementData.pinganData.creditDto.acctInfoList" :pagination="false" class="w100b be9e9e9 bsb mt22">

          <div slot="discntAcctName" slot-scope="text, record,index">
            <a-input class="be9e9e9 w180 " :class="[isNull('discntAcctName','acctInfoList',index)?'red': '']" placeholder="请输入贴现账户名称" size="small" v-model="agreementData.pinganData.creditDto.acctInfoList[index].discntAcctName"></a-input>
          </div>
          <div slot="discntAcctNo" slot-scope="text, record,index">
            <a-input class="be9e9e9  w180" :class="[isNull('discntAcctNo','acctInfoList',index)?'red': '']" placeholder="请输入贴现户账号" size="small" v-model="agreementData.pinganData.creditDto.acctInfoList[index].discntAcctNo"></a-input>
          </div>
          <div slot="discntAcctOpenBankName" slot-scope="text, record,index">
            <a-input class="be9e9e9 w180 " :class="[isNull('discntAcctOpenBankName','acctInfoList',index)?'red': '','beforeStar']" placeholder="请输入开户行名称" size="small" v-model="agreementData.pinganData.creditDto.acctInfoList[index].discntAcctOpenBankName"></a-input>
          </div>
          <div slot="discntAcctOpenBankNo" slot-scope="text, record,index">
            <a-input class="be9e9e9  w180" :class="[isNull('discntAcctOpenBankNo','acctInfoList',index)?'red': '']" placeholder="请输入开户行号" size="small" v-model="agreementData.pinganData.creditDto.acctInfoList[index].discntAcctOpenBankNo"></a-input>
          </div>

          <span slot="action" slot-scope="text,record,index"><i class="icon remove cp del_stockholder_sanxiang" @click="deleteStockHolder(index)"></i></span>
        </a-table>

      </div>
    </div>


    <!-- 7.文件资料 -->
    <div class="mt43">
      <div class="f13 c333"><i class="bgff8200 w3 h13 dl mr9"></i>8.补充资料 <span class="f12 c4772FF">文件格式：jpg、png、pdf、xlsx</span></div>
      <div class="content">

        <div class="fStart mt22 ">
          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">资产负债表：</div>
            <div class="dCC  cp h100" :class="[agreementData.pinganData.creditDto.balanceSheet?'': '', isNull('balanceSheet')?'red': '', 'fileUploadBg']" @click="imgUploadClick('balanceSheet')">

              <div class=" w180 h100 pr" :class="[agreementData.pinganData.creditDto.balanceSheet?'':'file']">
                <div class="pa pac tc cp  ">
                  <img src="~@/assets/img/account/PDF.png" v-if="getName(agreementData.pinganData.creditDto.balanceSheet) === 'pdf'" class="w40b" alt="">
                  <img src="~@/assets/img/account/xlx.png" v-else-if="getName(agreementData.pinganData.creditDto.balanceSheet) === 'xlsx'" class="w60b" alt="">
                  <img :src="agreementData.pinganData.creditDto.balanceSheet" alt="" v-else-if=" agreementData.pinganData.creditDto.balanceSheet &&(getName(agreementData.pinganData.creditDto.balanceSheet) !== 'xlsx' | getName(agreementData.pinganData.creditDto.balanceSheet) !== 'pdf')" class="w70b ">
                  <img src="~@/assets/img/account/xlx.png" v-else-if="!agreementData.pinganData.creditDto.balanceSheet" class="w60b" alt="">

                  <p class=" mt5 f12 c999" v-if="!agreementData.pinganData.creditDto.balanceSheet">点击上传</p>
                  <!-- <p class=" mt5 f12 c999" v-else-if="fileInfo.FileName.balanceSheet">{{fileInfo.FileName.balanceSheet}}</p> -->
                  <p v-else-if="fileInfo.FileName.balanceSheet" class=" mt5 f12 c999">{{fileInfo.FileName.balanceSheet ?fileInfo.FileName.balanceSheet.length > 20? fileInfo.FileName.balanceSheet.slice(0,14)+'...' +fileInfo.FileName.balanceSheet.split('.')[0].slice(-3) + '.'+fileInfo.FileName.balanceSheet.split('.')[1] :fileInfo.FileName.balanceSheet : ''}}</p>
                  <div class="mt5 f12 c999" v-if="agreementData.pinganData.creditDto.balanceSheet">
                    <span class="overView" @click="overView(agreementData.pinganData.creditDto.balanceSheet)">预览</span>
                    <span class="reUpload">重新上传</span>
                  </div>
                </div>
                <div class=" mask " v-if="false">
                  <div class="pa t0 r0 mt5 mr5">
                    <Button type="primary" size="small" @click="overView(agreementData.pinganData.creditDto.balanceSheet)">预览</Button>
                    <Button size="small" @click="overView(agreementData.pinganData.creditDto.balanceSheet)">重新上传</Button>
                  </div>
                </div>
              </div>
              <imgUpload class=" pinganCredit_benefitName w200 h100 dn" ref="balanceSheet" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.pinganData.creditDto.balanceSheet" :format="['jpg','jpeg','png','pdf','xlsx']" :fieldName="'balanceSheet'">
              </imgUpload>

            </div>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">利润表：</div>
            <div class="dCC  cp h100" :class="[ isNull('incomeStatement')?'red': '', 'fileUploadBg']" @click="imgUploadClick('incomeStatement')">
              <div class="  w180 h100 pr" :class="[agreementData.pinganData.creditDto.incomeStatement?'':'file']">
                <div class="pa pac tc cp">
                  <img src="~@/assets/img/account/PDF.png" v-if="getName(agreementData.pinganData.creditDto.incomeStatement) === 'pdf'" class="w40b" alt="">
                  <img src="~@/assets/img/account/xlx.png" v-else-if="getName(agreementData.pinganData.creditDto.incomeStatement) === 'xlsx'" class="w60b" alt="">
                  <img :src="agreementData.pinganData.creditDto.incomeStatement" alt="" v-else-if="getName(agreementData.pinganData.creditDto.incomeStatement) !== 'xlsx' | getName(agreementData.pinganData.creditDto.incomeStatement) !== 'pdf'" class="w80b">

                  <img src="~@/assets/img/account/xlx.png" v-if="!agreementData.pinganData.creditDto.incomeStatement" class="w60b" alt="">
                  <p class=" mt5 f12 c999" v-if="!agreementData.pinganData.creditDto.incomeStatement">点击上传</p>
                  <p v-else-if="fileInfo.FileName.incomeStatement" class=" mt5 f12 c999">{{fileInfo.FileName.incomeStatement ?fileInfo.FileName.incomeStatement.length > 20? fileInfo.FileName.incomeStatement.slice(0,14)+'...' +fileInfo.FileName.incomeStatement.split('.')[0].slice(-3) + '.'+fileInfo.FileName.incomeStatement.split('.')[1] :fileInfo.FileName.incomeStatement : ''}}</p>
                  <div class="mt5 f12 c999" v-if="agreementData.pinganData.creditDto.incomeStatement">
                    <span class="overView" @click="overView(agreementData.pinganData.creditDto.incomeStatement)">预览</span>
                    <span class="reUpload">重新上传</span>
                  </div>
                </div>
                <div class=" mask " v-if="false">
                  <div class="pa t0 r0 mt5 mr5">
                    <Button type="primary" size="small" @click="overView(agreementData.pinganData.creditDto.incomeStatement)">预览</Button>
                    <Button size="small" @click="overView(agreementData.pinganData.creditDto.incomeStatement)">重新上传</Button>
                  </div>
                </div>
              </div>
              <imgUpload class=" pinganCredit_benefitName dn" ref="incomeStatement" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.pinganData.creditDto.incomeStatement" :format="['jpg','jpeg','png','pdf','xlsx']" :fieldName="'incomeStatement'">
              </imgUpload>

            </div>
          </div>

          <div class="fStart w33b aic">
            <div class="mr13  w150 tr">现金流量表：</div>
            <div class="dCC  cp h100" :class="[agreementData.pinganData.creditDto.cashFlowStatement?'': 'noFile', isNull('cashFlowStatement')?'red': '', 'fileUploadBg']" @click="imgUploadClick('cashFlowStatement')">
              <div class="  w180 h100 pr" :class="[agreementData.pinganData.creditDto.cashFlowStatement?'':'file']">
                <div class="pa pac tc cp">
                  <img src="~@/assets/img/account/PDF.png" v-if="getName(agreementData.pinganData.creditDto.cashFlowStatement) === 'pdf'" class="w40b" alt="">
                  <img src="~@/assets/img/account/xlx.png" v-else-if="getName(agreementData.pinganData.creditDto.cashFlowStatement) === 'xlsx'" class="w60b" alt="">
                  <img :src="agreementData.pinganData.creditDto.cashFlowStatement" alt="" v-else-if="agreementData.pinganData.creditDto.cashFlowStatement &&(getName(agreementData.pinganData.creditDto.cashFlowStatement) !== 'xlsx' | getName(agreementData.pinganData.creditDto.cashFlowStatement) !== 'pdf')" class="w70b ">
                  <img src="~@/assets/img/account/xlx.png" v-else-if="!agreementData.pinganData.creditDto.cashFlowStatement" class="w60b" alt="">

                  <p class=" mt5 f12 c999" v-if="!agreementData.pinganData.creditDto.cashFlowStatement">点击上传</p>
                  <!-- <p class=" mt5 f12 c999" v-else-if="fileInfo.FileName.cashFlowStatement">{{fileInfo.FileName.cashFlowStatement}}</p> -->
                  <p v-else-if="fileInfo.FileName.cashFlowStatement" class=" mt5 f12 c999">{{fileInfo.FileName.cashFlowStatement ?fileInfo.FileName.cashFlowStatement.length > 20? fileInfo.FileName.cashFlowStatement.slice(0,14)+'...' +fileInfo.FileName.cashFlowStatement.split('.')[0].slice(-3) + '.'+fileInfo.FileName.cashFlowStatement.split('.')[1] :fileInfo.FileName.cashFlowStatement : ''}}</p>
                  <div class="mt5 f12 c999" v-if="agreementData.pinganData.creditDto.cashFlowStatement">
                    <span class="overView" @click="overView(agreementData.pinganData.creditDto.cashFlowStatement)">预览</span>
                    <span class="reUpload">重新上传</span>
                  </div>
                </div>
                <div class=" mask " v-if="false">
                  <div class="pa t0 r0 mt5 mr5">
                    <Button type="primary" size="small" @click="overView(agreementData.pinganData.creditDto.cashFlowStatement)">预览</Button>
                    <Button size="small" @click="overView(agreementData.pinganData.creditDto.cashFlowStatement)">重新上传</Button>
                  </div>
                </div>
              </div>
              <imgUpload class=" pinganCredit_benefitName dn" ref="cashFlowStatement" @change="filChange" :params="{ isShowImg: false}" :showUrl="agreementData.pinganData.creditDto.cashFlowStatement" :format="['jpg','jpeg','png','pdf','xlsx']" :fieldName="'cashFlowStatement'">
              </imgUpload>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt43 pb20 ">
      <p class="" v-if="bankSubDto.nodeMessage"><span>节点：</span> {{bankSubDto.nodeMessage}}</p>
      <p>
        <Checkbox v-model:value="infoCollectAuthLetterAgree">我已阅读并同意签署</Checkbox>
        <span>
          <a href="/static/html/平安银行-企业信息采集使用授权书.pdf" target="_blank" class="hoverunder">《企业信息采集使用授权书》</a>
        </span>
      </p>
      <div class="fJCenter">
        <Button class="w110 btnff8200bg tc cp br4 submit" v-if="bankSubDto.status === 'NO_CREDIT' || bankSubDto.status ===  'CREDIT_FAIL'" type="primary" @click="submit('applyCredit')">申请签约</Button>
        <Button class="w110 btnff8200bg tc cp br4 submit" v-else-if="bankSubDto.status === 'CREDIT_SUCCESS'" type="primary" @click="submit('replenish')">信息补录</Button>
      </div>

    </div>

  </div>

</template>

<script>
import "@/assets/js/foundation-datepicker.js";
import "@/assets/js/maturityTandem.js";
import imgUpload from '../module/imgUpload.vue'
import 'ant-design-vue/dist/antd.css'
import { Checkbox } from 'ant-design-vue';
let _this = '';

export default {
  name: "agreementMenu",
  components: {
    imgUpload
  },
  props: ['bankId'],
  data () {
    return {
      infoCollectAuthLetterAgree: true,
      agreementData: {
        // 三湘协议请求参数--自渠道
        pinganData: {
          creditDto: {
            name: "", //企业名称
            idType: "", //证件类型：1-统一社会信用代码
            idNo: "", //证件号码
            salesRevenue: "", //年销售额，单位：元，最多保留两位小数
            oprrName: "", //经办人姓名
            oprrTel: "", //经办人手机号
            legalPsnName: "", //法人姓名
            blicPic: "", //营业执照图片，img,png,pdf
            lepPicA: "", //法人身份证人像面，img,png,pdf
            lepPicB: "", //法人身份证国徽面，img,png,pdf
            balanceSheet: "", //资产负债表，格式：xlsx
            incomeStatement: "", //利润表，格式：xlsx
            cashFlowStatement: "", //现金流量表，格式：xlsx
            businessBank: undefined, //业务处理行
            legalPsnIdNo: "", //法人证件号
            nationalTaxNo: "", //国税纳税人识别号
            localTaxNo: "", //地税纳税人识别号
            legalPsnIdType: "1", //法人证件类型 1-身份证
            legalPsnProvCd: "", //法人联系城市-省代码
            legalPsnCityCd: "", //法人联系城市-市代码
            legalPsnDetailAddr: "", //法人联系地详细地址
            legalPsnIdDueDateFlag: "", //法人证件到期日是否长期，1-长期、0-不是长期
            legalPsnIdDueDate: '', //法人证件到期日，格式：yyyy-MM-dd，长期上送9999-12-31
            shareholderType: "", //控股股东类型(0个人 1企业)
            shareholderIdType: "1", //控股股东证件类型，如果控股股东是企业的话传空，1-身份证
            shareholderName: "", //控股股东姓名
            shareholderProvCd: "", //控股股东联系城市-省代码
            shareholderCityCd: "", //控股股东联系城市-市代码
            shareholderDetailAddr: "", //控股股东联系地详细地址
            shareholderIdNo: "", //控股股东证件号码
            shareholderIdDueDateFlag: "", //控股股东证件到期日是否长期，1-长期 0-不是长期
            shareholderIdDueDate: '', //控股股东证件到期日，格式：yyyy-MM-dd，长期上送9999-12-31
            stockholderCertAFile: "", //股东个人身份证正面，img,png,pdf
            stockholderCertBFile: "", //股东个人身份证反面，img,png,pdf
            stockholderBilcFile: "", //股东营业执照文件，img,png,pdf
            beneficiaryList: [
              {
                idType: "1", //受益人证件类型，1 身份证
                name: "", //受益人姓名
                idNo: "", //受益人证件号码
                provCd: "", //受益人联系城市-省代码
                cityCd: "", //受益人联系城市-市代码
                areaCd: "", //受益人联系城市-区代码
                detailAddr: "", //受益人联系地详细地址
                idNoDueDateFlag: "", //受益人证件到期日是否长期，1-长期 0-不是长期
                idNoDueDate: '', //受益人证件到期日，格式：yyyy-MM-dd，长期上送9999-12-31
                benefitCertAFile: "", //受益人身份证正面
                benefitCertBFile: "" //受益人身份证反面
              }
            ], //受益人信息
            acctInfoList: [
              {
                discntAcctName: "", //贴现账户名称
                discntAcctNo: "", //贴现账号
                discntAcctOpenBankName: "", //贴现账户开户行名称
                discntAcctOpenBankNo: "" //贴现账户开户行号
              }
            ] //贴现账户列表实体
          }

        },
        bankId: '',
        // 协议参数名
        paramName: "pinganData", //

        // 下拉选择参数列表
        baseDate: {
          // 国标行业分类(兴业提供的编码)
          industryType: [],
          // 机构类型
          orgType: [],
          // 企业类型
          corpType: [],
          // 证件类型
          certType: [],
          // 地区信息（兴业提供的编码）
          areaCode: [],
        },

        // 当前签约银行的行业分类
        cuIndustry: ''
      },
      // 匹配规则
      rules: {
        oprrName: { required: true, validator: /[\u4e00-\u9fa5]+/ }, // 匹配中文
        oprrTel: { required: true, validator: /\d{11}/ }, // 匹配11位数字
      },
      bankSubDto: {
        status: '',
        node: '',
        nodeDesc: '',
        nodeMessage: ''
      },
      FileName: {
        balanceSheet: '', //上一年度资产负债表文件
        incomeStatement: '', //上一年度利润表文件
        cashFlowStatement: '', //上一年度现金流量表文件
        subsidiaryRegisterAuthorizationFile: '', //分公司注册授权书
        openAcctLicenceFile: '' //开户许可证
      },
      params: {
        ocr: false,
        loadding: false,// 上传中 Loading 效果
        isShowImg: true,// 图片预览
        isReUpload: false, // 是否展示重新上传按钮
        ocr: { // ocr 识别
          picType: 'blicPicOss'// 上传图片类型 用于OCR识别
        },
        required: true
      },
      benefitArray: {
        columns: [
          {
            title: <span>姓名<span class="beforeStar"></span></span>,
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' }
          },
          {
            title: <span>证件类型<span class="beforeStar"></span></span>,
            dataIndex: 'idType',
            scopedSlots: { customRender: 'idType' }
          },
          {
            title: <span>证件号码<span class="beforeStar"></span></span>,
            dataIndex: 'idNo',
            scopedSlots: { customRender: 'idNo' }
          },
          {
            title: <span>证件到期日<span class="beforeStar"></span></span>,
            dataIndex: 'idNoDueDate',
            scopedSlots: { customRender: 'idNoDueDate' }
          },
          {
            title: <span>联系地址<span class="beforeStar"></span></span>,
            dataIndex: 'provCd',
            scopedSlots: { customRender: 'provCd' }
          },

          {
            title: <span>身份证正/反面<span class="beforeStar"></span></span>,
            colSpan: 2,
            dataIndex: 'benefitCertAFile',
            scopedSlots: { customRender: 'benefitCertAFile' }
          },
          {
            title: '',
            colSpan: 0,
            dataIndex: 'benefitCertBFile',
            scopedSlots: { customRender: 'benefitCertBFile' }
          },
          {
            title: <span>联系详细地址<span class="beforeStar"></span></span>,
            dataIndex: 'detailAddr',
            scopedSlots: { customRender: 'detailAddr' }
          },
          {
            title: '',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        data: []
      },
      businessBankListOptions: undefined,
      acctInfoList: {
        columns: [
          {
            title: <span>贴现账户名称<span class="beforeStar"></span></span>,
            dataIndex: 'discntAcctName',
            scopedSlots: { customRender: 'discntAcctName' }
          },
          {
            title: <span>贴现账号<span class="beforeStar"></span></span>,
            dataIndex: 'discntAcctNo',
            scopedSlots: { customRender: 'discntAcctNo' }
          },
          {
            title: <span>贴现账户开户行名称<span class="beforeStar"></span></span>,
            dataIndex: 'discntAcctOpenBankName',
            scopedSlots: { customRender: 'discntAcctOpenBankName' }
          },
          {
            title: <span>贴现账户开户行号<span class="beforeStar"></span></span>,
            dataIndex: 'discntAcctOpenBankNo',
            scopedSlots: { customRender: 'discntAcctOpenBankNo' }
          },
          {
            title: '',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        data: []
      },
      checkedFlag: false, // 校验标识
      changeAupParamsFlag: false, // 变更经办人校验标识
      applyQuotaParamsFlag: false, // 申请提额校验标识

      // 是否存储当前数据
      saveData: true,
      uploadNum: 0,
      none_ststus: false, // 判断是否存在没有填写的数据

      fileInfo: {
        applyQuotaParams: {
          balanceSheet: "",
          incomeStatement: "",
          cashFlowStatement: ''
        },
        FileName: {
          balanceSheet: '', //上一年度资产负债表文件
          incomeStatement: '', //上一年度利润表文件
          cashFlowStatement: '', //上一年度现金流量表文件
        },
      },
      SXModelMoney: false, // 小额鉴定
      SXStatus: false,
      SXmoney: '',
      SXAcctInfo: '',
      imgIndex: ''

    }
  },
  filters: {
    formatterMobile (value) {
      if (value && value.length == 11) {
        let mobile = value.slice(0, 3) + '-' + value.slice(3, 7) + '-' + value.slice(7);
        return mobile
      }
      return '';
    }
  },
  mounted () {

    console.log($(".relevanceCompany"), 'mounted');
    console.log(this);
  },
  computed: {
    benefitCertAddress () {
      return (record) => {
        return [record.provCd, record.cityCd, record.areaCd]
      }
    },
    legalPsnAddress () {
      return () => {
        return [this.agreementData.pinganData.creditDto.legalPsnProvCd, this.agreementData.pinganData.creditDto.legalPsnCityCd]
      }
    },
    shareholderAddress () {
      return () => {
        return [this.agreementData.pinganData.creditDto.shareholderProvCd, this.agreementData.pinganData.creditDto.shareholderCityCd]
      }
    },
  },
  created () {
    _this = this;
    console.log('this.$route.params.id', this.$route, '*******', _this.bankId, this.$route.query);
    // 页面跳转
    if (_this.bankId) {
      this.agreementData.bankId = _this.bankId
      this.syncSignBankStatus(_this.bankId)
    }

    // if (this.$route.params.id) {
    //   this.agreementData.bankId = this.$route.params.id
    //   this.syncSignBankStatus(this.$route.params.id)
    // }


    // 监听页面刷新、跳转
    window.addEventListener("beforeunload", hashChangeFire);
    window.onbeforeunload = hashChangeFire;
    window.onunload = hashChangeFire;
    function hashChangeFire () {
      console.log('-----');
      _this.saveData ? sessionStorage.setItem('signBank' + _this.agreementData.bankId, JSON.stringify(_this.agreementData)) : '';        // 存储数据
      _this.saveData ? localStorage.setItem('signBank' + _this.agreementData.bankId, JSON.stringify(_this.agreementData)) : '';
    }
  },
  beforeDestroy () {
    console.log('this.agreementData***', this.saveData, this.agreementData.bankId, 'signBank' + this.agreementData.bankId, this.agreementData);
    this.saveData ? localStorage.setItem('signBank' + this.agreementData.bankId, JSON.stringify(this.agreementData)) : '';        // 存储数据
  },


  methods: {
    // 初始化数据
    initData (bankId) {
      _this.addLoading();
      // 请求初始化数据参数
      this.sendGet({
        method: 'get',
        url: '/web/discount-acct/bank/credit',
        data: {
          bank_id: bankId,
        },
      }, (result) => {
        this.checkedFlag = false // 校验标识
        let data = result.data.data
        let localData = JSON.parse(localStorage.getItem('signBank' + this.agreementData.bankId))
        this.agreementData.baseDate = Object.assign({}, this.agreementData.baseDate, data.creditParam)
        this.agreementData.pinganData.creditDto = (data.status === 'NO_CREDIT' && localData) ? Object.assign({}, this.agreementData.pinganData.creditDto, localData.pinganData.creditDto) : Object.assign({}, this.agreementData.pinganData.creditDto, data.bankSubDto.creditDto)

        this.bankSubDto.status = data.status
        this.bankSubDto.node = data.bankSubDto.node ? data.bankSubDto.node : ''
        this.bankSubDto.nodeDesc = data.bankSubDto.nodeDesc ? data.bankSubDto.nodeDesc : ''
        this.bankSubDto.nodeMessage = data.bankSubDto.nodeMessage ? data.bankSubDto.nodeMessage : ''
        const pinganDataCreditDto = this.agreementData.pinganData.creditDto

        this.agreementData.pinganData.creditDto.legalPsnIdType = pinganDataCreditDto.legalPsnIdType ? pinganDataCreditDto.legalPsnIdType : '1'
        this.agreementData.pinganData.creditDto.shareholderIdType = (this.agreementData.pinganData.creditDto.shareholderType === '1' || this.agreementData.pinganData.creditDto.shareholderIdType) ? this.agreementData.pinganData.creditDto.shareholderIdType : '1'

        console.log(data.creditParam);

        _this.agreementData.pinganData.creditDto.acctInfoList = (pinganDataCreditDto.acctInfoList && pinganDataCreditDto.acctInfoList.length) > 0 ? pinganDataCreditDto.acctInfoList : [{
          discntAcctName: "", //贴现账户名称
          discntAcctNo: "", //贴现账号
          discntAcctOpenBankName: "", //贴现账户开户行名称
          discntAcctOpenBankNo: "" //贴现账户开户行号
        }]
        _this.agreementData.pinganData.creditDto.beneficiaryList = (pinganDataCreditDto.beneficiaryList && pinganDataCreditDto.beneficiaryList.length > 0) ? pinganDataCreditDto.beneficiaryList : [{
          idType: "1", //受益人证件类型，1 身份证
          name: "", //受益人姓名
          idNo: "", //受益人证件号码
          provCd: "", //受益人联系城市-省代码
          cityCd: "", //受益人联系城市-市代码
          areaCd: "", //受益人联系城市-区代码
          detailAddr: "", //受益人联系地详细地址
          idNoDueDateFlag: "", //受益人证件到期日是否长期，1-长期 0-不是长期
          idNoDueDate: "", //受益人证件到期日，格式：yyyy-MM-dd，长期上送9999-12-31
          benefitCertAFile: "", //受益人身份证正面
          benefitCertBFile: "" //受益人身份证反面
        }]

        _this.businessBankListOptions = []
        _this.agreementData.baseDate.businessBankList.map(item => {
          _this.businessBankListOptions.push({ value: item.code, label: item.name, ...item })
        })

      }, error => {
        // 失败
      })
    },

    onCheckedDate (type, keyName, index) {
      if (keyName) {
        const date = (new Date(this.compatibilityIEDate(this.agreementData.pinganData.creditDto[keyName][index][`${type}`]))).pattern("yyyy-MM-dd")
        this.agreementData.pinganData.creditDto[keyName][index][`${type}`] = date
        this.agreementData.pinganData.creditDto[keyName][index][`${type}` + 'Flag'] = 0
      } else {
        this.agreementData.pinganData.creditDto[`${type}` + 'Flag'] = 0
        const date = (new Date(this.compatibilityIEDate(this.agreementData.pinganData.creditDto[`${type}`]))).pattern("yyyy-MM-dd")
        this.agreementData.pinganData.creditDto[`${type}`] = date
      }
    },
    shareholderTypeChange (e) {
      this.agreementData.pinganData.creditDto.shareholderIdNo = ''
    },

    // 日期长期函数
    langDate (type, name, index) {
      if (name) {
        this.agreementData.pinganData.creditDto.beneficiaryList[index].idNoDueDateFlag = 1
        this.agreementData.pinganData.creditDto.beneficiaryList[index].idNoDueDate = '9999-12-31'
      } else {
        switch (type) {
          case 'legalPsnIdDueDate':
            this.agreementData.pinganData.creditDto.legalPsnIdDueDateFlag = 1
            break;
          case 'shareholderIdDueDate':
            this.agreementData.pinganData.creditDto.shareholderIdDueDateFlag = 1
            break;
        }
        this.agreementData.pinganData.creditDto[type] = '9999-12-31'
      }
    },

    isNull (e, r, index, type) {
      if (type) {
        return this[`${type}` + 'Flag'] && !this[type][e]
      } else {
        if (r) {
          return this.checkedFlag && !this.agreementData.pinganData.creditDto[r][index][e]
        } else {
          let res = this.agreementData.pinganData.creditDto[e]
          // !/^((1)+\d{10})$/.test(this.formValidate.lepMobile)
          return this.checkedFlag && !res
        }
      }

    },
    // 失去焦点验证正则
    handleValidate (item) {
      if (_this.agreementData.pinganData.creditDto[item]) {
        if (_this.rules[item].validator.test(`${_this.agreementData.pinganData.creditDto[item]}`)) {
          // $('.pinganCredit' + '_' + item).removeClass('red');
          if ($('.pinganCredit' + '_' + item).next().length > 0) {
            $('.pinganCredit' + '_' + item).next().remove();
          }
          return false

        } else {
          if ($('.pinganCredit' + '_' + item).length > 0) {
            // console.log('before 匹配错误', data[i][j], j, _this.rules[j].validator, `${data[i][j]}`, _this.rules[j].validator.test(data[i][j]));
            if ($('.pinganCredit' + '_' + item).next().length < 1) {
              $('.pinganCredit' + '_' + item).after('<span class="cFF3B2F mt5">输入有误，请重新输入 </span>');
            }
            return true
          }
        }
      } else {
        if ($('.pinganCredit' + '_' + item).length > 0) {
          // $('.pinganCredit' + '_' + item).addClass('red');
          if ($('.pinganCredit' + '_' + item).next().length > 0) {
            $('.pinganCredit' + '_' + item).next().remove();
          }
          return this.checkedFlag
        }

      }

    },
    // 金额输入框聚焦事件
    onfocus (type) {
      _this.$set(_this.agreementData.pinganData.creditDto, `${type}` + 'Str', null)
    },
    onblur (item) {
      if (this.agreementData.pinganData.creditDto[item]) {
        let nub = _this.agreementData.pinganData.creditDto[item]
        // _this.$set(_this.agreementData.pinganData.creditDto, `${item}` + 'Str', this.formatMoney(nub, 2, ''))
        _this.agreementData.pinganData.creditDto[item] = null
        _this.agreementData.pinganData.creditDto[item] = nub

      } else {
        _this.$set(this.agreementData.pinganData.creditDto, `${item}` + 'Str', null)
      }
    },
    // 资料预览下载
    overView (url) {
      window.open(url)
    },
    getName (name) {

      if (name) {
        let str = name.slice(name.length - 5, name.length)
        console.log(name, str);

        return str.split('.')[1]
      } else {
        return ''
      }
    },

    // 根据地区code获取地区名称
    findNameByAreaCode: function (list, code) {
      if (!code) return '';
      for (var i in list) {
        if (list[i].code == code) {
          return list[i].name;
        } else {
          if (list[i].subList != null) {
            var res = this.findNameByAreaCode(list[i].subList, code);
            if (res) { return res }
          }
        }
      }
    },

    // 签约上传图片函数
    handleChange (ossData, ocrData, type) {
      console.log('***************', ossData);
      let that = this
      if (ossData) {

        switch (type) {
          case 'blicPicOss':
            console.log(type);
            this.agreementData.pinganData.creditDto.blicPic = ossData.url
            if (ocrData) {
              that.agreementData.pinganData.creditDto.name = ocrData.data.name; // 识别的公司名称
            }

            break;
          case 'lepPicAOss':
            that.agreementData.pinganData.creditDto.lepPicA = ossData.url
            if (ocrData) {
              that.agreementData.pinganData.creditDto.legalPsnName = ocrData.data.name; // 法人姓名
              that.agreementData.pinganData.creditDto.legalPsnIdNo = ocrData.data.num; // 法人证件号
              // that.agreementData.pinganData.creditDto.legalPsnDetailAddr = ocrData.data.address; // 法人证件号
            }

            break;
          case 'lepPicBOss':
            that.agreementData.pinganData.creditDto.lepPicB = ossData.url
            if (ocrData) {
              // that.agreementData.pinganData.creditDto.artifIdtStartDate = ocrData.data.start_date; // 识别的公司名称
              that.agreementData.pinganData.creditDto.legalPsnIdDueDate = ocrData.data.end_date === '长期' ? '9999-12-31' : ocrData.data.end_date; // 识别的公司名称
            }

            break;
          case 'aupPicAOss':
            that.agreementData.pinganData.creditDto.stockholderCertAFile = ossData.url
            if (ocrData) {
              that.agreementData.pinganData.creditDto.shareholderName = ocrData.data.name; // 识别的公司名称
              that.agreementData.pinganData.creditDto.shareholderIdNo = ocrData.data.num; // 识别的公司名称
            }

            break;
          case 'aupPicBOss':
            that.agreementData.pinganData.creditDto.stockholderCertBFile = ossData.url
            if (ocrData) {
              that.agreementData.pinganData.creditDto.shareholderIdDueDate = ocrData.data.end_date === '长期' ? '9999-12-31' : ocrData.data.end_date; // 识别的公司名称
            }

            break;

        }
      }
    },

    // 资料重新上传
    imgUploadClick (e, type, index) {
      this.$refs[e].reUpload()
    },

    stockholderChange (ossData, ocrData) {
      this.agreementData.pinganData.creditDto.stockholderBilcFile = ossData.url
      if (ocrData) {
        // this.agreementData.pinganData.creditDto.name = ocrData.data.name; // 识别的公司名称
        this.agreementData.pinganData.creditDto.shareholderIdNo = ocrData.data.reg_num; // 识别的统一社会信用代码
      }
    },

    // 受益人证件上传函数
    imgUploadClicks (e, type, index) {
      console.log(e, index, this.imgIndex, this.$refs[e]);
      switch (type) {
        case 'agreement':
          this.$refs[e].reUpload()
          break;
        case 'img':
          this.$refs[e].reUpload()
          this.imgIndex = index
          break;
        case 'other':
          this.$refs[e].reUpload()
          break;
      }


      if (index) {
        this.imgIndex = index
      }

      console.log(e, index, this.imgIndex);
    },

    benefitCertAFileChange (emeit, ossData) {
      this.$set(this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], 'benefitCertAFile', emeit.url)
      if (ossData) {
        console.log(emeit, this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], ossData.data);
        this.$set(this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], 'name', ossData.data.name)
        this.$set(this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], 'idNo', ossData.data.num)
      }
    },

    benefitCertBFileChange (emeit, ossData) {
      console.log(emeit, this.imgIndex, ossData);
      this.$set(this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], 'benefitCertBFile', emeit.url)
      if (ossData) {
        this.$set(this.agreementData.pinganData.creditDto.beneficiaryList[this.imgIndex], 'idNoDueDate', ossData.data.end_date === '长期' ? '9999-12-31' : ossData.data.end_date)
      }
    },

    // 现金流量表
    filChange (name, url, fieldName) {
      // console.log(name, 'url', url, fieldName, 'e', Object.prototype.toString.call(name));
      if (Object.prototype.toString.call(name) === '[object Object]') {
        this.agreementData.pinganData.creditDto[url] = name.url
        this.fileInfo.FileName[url] = fieldName
      } else {
        this.agreementData.pinganData.creditDto[fieldName] = url
        this.fileInfo.FileName[fieldName] = name
      }
    },

    // 增加受益人
    addBeneficiary () {
      if (this.agreementData.pinganData.creditDto.beneficiaryList && this.agreementData.pinganData.creditDto.beneficiaryList.length == 3) {
        this.$Message.error("最终受益人信息最多可填写三个");
        return false;
      }
      this.agreementData.pinganData.creditDto.beneficiaryList.push({
        idType: "1", //受益人证件类型，1 身份证
        name: "", //受益人姓名
        idNo: "", //受益人证件号码
        provCd: "", //受益人联系城市-省代码
        cityCd: "", //受益人联系城市-市代码
        areaCd: "", //受益人联系城市-区代码
        detailAddr: "", //受益人联系地详细地址
        idNoDueDateFlag: "", //受益人证件到期日是否长期，1-长期 0-不是长期
        idNoDueDate: "", //受益人证件到期日，格式：yyyy-MM-dd，长期上送9999-12-31
        benefitCertAFile: "", //受益人身份证正面
        benefitCertBFile: "" //受益人身份证反面
      })
    },

    // 删除受益人
    deleteBeneficiary (index) {
      if (this.agreementData.pinganData.creditDto.beneficiaryList.length > 1) {
        this.agreementData.pinganData.creditDto.beneficiaryList.splice(index, 1)
      }
    },

    // 增加股东信息
    addStockHolder () {
      if (this.agreementData.pinganData.creditDto.acctInfoList.length < 5) {
        this.agreementData.pinganData.creditDto.acctInfoList.push({
          discntAcctName: this.agreementData.pinganData.creditDto.name, //贴现账户名称
          discntAcctNo: "", //贴现账号
          discntAcctOpenBankName: "", //贴现账户开户行名称
          discntAcctOpenBankNo: "" //贴现账户开户行号
        })
      }
    },
    // 删除股东信息
    deleteStockHolder (index) {
      if (this.agreementData.pinganData.creditDto.acctInfoList.length > 1) {
        this.agreementData.pinganData.creditDto.acctInfoList.splice(index, 1)
      }
    },
    // 地址级联选择
    onChange (val, record) {
      console.log(val, record);
      if (Object.prototype.toString.call(record) === '[object String]') {
        switch (record) {
          case 'shareholder':
            this.agreementData.pinganData.creditDto.shareholderProvCd = val.length > 0 ? val[0] : ''
            this.agreementData.pinganData.creditDto.shareholderCityCd = val.length > 0 ? val[1] : ''
            break;
          case 'legalPsn':
            this.agreementData.pinganData.creditDto.legalPsnProvCd = val.length > 0 ? val[0] : ''
            this.agreementData.pinganData.creditDto.legalPsnCityCd = val.length > 0 ? val[1] : ''
            break;
        }
      } else {
        if (val && val.length >= 3) {
          record.provCd = val[0]
          record.cityCd = val[1]
          record.areaCd = val[2]
        }
      }
    },

    syncSignBankStatus (bankId) {
      // 同步贴现企业签约银行状态
      this.sendGet({
        url: '/web/discount-acct/bank/sync',
        data: {
          bank_id: bankId
        },
      }, (result) => {
        // console.log("ack回调", result);
        _this.initData(bankId);
      }, (result) => {
        // console.log("其他回调", result);
      })

    },

    // 提交数据
    submit (type) {
      if (!this.infoCollectAuthLetterAgree) {
        this.$Message.warning("请先阅读并同意《企业信息采集使用授权书》");
        return false;
      }
      console.log(this.agreementData);
      this.checkedFlag = true // 校验标识
      this.$nextTick(() => {
        if (this.checkData(type)) {
          _this.$Message.warning("请先完善页面相关信息");
          return false;
        }

        _this.addLoading();
        let requestData = {};
        requestData.bankPingan = this.agreementData.pinganData;
        console.log(requestData.bankPingan);

        switch (type) {
          case 'applyCredit':
            _this.submitData(requestData, '/web/discount-acct/apply-credit/', 'put', true);
            break;
          case 'replenish':
            // 信息补录
            _this.submitData(requestData, '/web/pingan-discount/credit-replenish/', 'post');
            break;
        }
      })

    },

    checkData (element) {
      let el
      let first_none_value_node
      if (element !== 'applyCredit' || element !== 'changeCredit') {
        first_none_value_node = document.querySelector('.red')
      } else {
        el = document.getElementById(`${element}`)
        first_none_value_node = el ? el.querySelector('.red') : document.querySelector('.red')
      }
      if (first_none_value_node) {
        first_none_value_node.scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block: 'center', //居中
        })
        return true

      } else {
        return false
      }
    },

    // 提交数据
    submitData (requestData, url, methodType, isSync) {
      if (_this.uploadNum > 0) {
        _this.removeLoading();
        this.$Message.error('请等待文件上传成功之后再提交');
        return false;
      }
      if (!url) {
        url = '/web/discount-acct/bank/';
      }
      // 提交
      this.sendOther({
        url: url + _this.bankId,
        data: requestData,
        method: methodType ? methodType : 'put'
      }, (result) => {
        localStorage.removeItem('signBank' + _this.bankId);
        this.saveData = false;
        this.$Message.success(result.data.message);
        this.initData(_this.bankId);
        // this.initData(_this.$route.params.id);
        if (isSync) {
          // _this.syncSignBankStatus(this.$route.params.id)
          _this.syncSignBankStatus(_this.bankId)
        }

      }, (result) => {
        // // console.log("其他回调", result);
      })
    }
  },

}
</script>

<style scoped>
@import '../../../static/css/foundation-datepicker.less';
@import '../../../static/css/main.less';
.yyzz {
  width: 128px !important;
  height: 130px !important;
  background: url(~@/assets/img/account/word_jpp@2x.png) no-repeat center center;
  border: none;
}
.sfz {
  width: 128px;
  height: 80px;
}
.borderLine {
  border: 1px solid #ccc;
  border-radius: 4px;
}
/* .noFile {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100px;
  height: 100px;
} */
.ivu_wh100 .ivu-spin-main,
.ivu_wh100 .ivu-spin-text {
  width: 100%;
  height: 100%;
}
/* 公共样式 */
.beforeStar::before {
  content: '*';
  margin-right: 4px;
  color: #d0021b;
}
.l124 {
  line-height: 124px;
}

input::-webkit-input-placeholder {
  color: #ccc;
}

/* 图片上传样式 */
.bgcolor {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}
.img_hover_style {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  display: flex;
}
.img_hover_style > div {
  display: none;
}
.img_hover_style:hover > div {
  display: block;
}

/* 多级联动 */
.level li:hover {
  background-color: #fdf8e9;
  color: #e9b722;
  cursor: pointer;
}
.level li.active {
  font-weight: 700;
  color: #e9b722;
  background-color: #fbf1d3;
}
.level li {
  padding-left: 5px;
}

.level::-webkit-scrollbar {
  display: none;
}

.level {
  position: absolute;
  left: 0px;
  top: 23px;
  height: 300px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  z-index: 8;
}
.level1 {
  left: 0px;
  width: 144px;
  top: 23px;
}
.level2 {
  left: 50px;
  width: 144px;
  top: 23px;
}
.level3 {
  left: 100px;
  width: 144px;
  top: 23px;
}
.level4 {
  left: 150px;
  width: 144px;
  top: 23px;
}
.red {
  border-color: #d0021b !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 4px #d0021b;
}
.agreement .upload_img {
  background-image: none;
}
.img_style {
  background-size: contain !important;
}
.img_style_82 {
  background-size: 82px !important;
}
/*删除按钮*/
.icon.remove {
  width: 13px;
  height: 17px;
  background: url(~@/assets/img/account/icon_delete@2x.png) no-repeat center
    center;
  background-size: contain;
  vertical-align: -3px;
  display: inline-block;
}

.agreement .h23.ivu-select-single .ivu-select-selection {
  height: 23px;
  line-height: 23px;
  padding: 0;
  margin: 0;
}

.agreement .ivu-select .ivu-select-dropdown {
  width: 100%;
}

.agreement .h23 .ivu-select-input {
  height: 23px;
}
</style>
<style lang="less" scoped>
.tip {
  cursor: pointer;
  width: 90px;
  // position: absolute;
  // left: 27%;
  &:hover {
    .tipShow {
      display: block;
    }
  }

  .tipShow {
    display: none;
    position: absolute;
    top: -48px;
    left: 0;
    width: 200px;
    height: 44px;
    padding: 4px 10px;
    background: #ccc;
    border-radius: 4px;
    color: #484848;
  }
  .tipShow::before {
    height: 0;
    width: 0;
    content: '';
    border: 6px solid #ccc;
    border-right-color: transparent;
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-top: 6px solid #ccc;
    position: absolute;
    bottom: -10px;
    left: 20px;
  }
}
.benefitCert /deep/ .imgUpload-file-btn {
  font-size: 12px;
}
.imgUpload {
  &:hover {
    color: #ff8200;
  }
}
.fileUploadBg:hover {
  p {
    color: #ff8200;
  }
}
.overView:hover {
  color: #ff8200;
}
.reUpload {
  margin-left: 10px;
  &:hover {
    color: #ff8200;
  }
}
.file {
  .mask {
    display: none;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  &:hover {
    .mask {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BankAgreementPingAn.vue